"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRelativeRange = exports.DateRangeDropdown = void 0;
var react_1 = __importStar(require("react"));
var css_1 = require("@emotion/css");
var date_fns_1 = require("date-fns");
var Dropdown_1 = require("../Dropdown");
var design_system_layouts_1 = require("@contrast-security-inc/design-system-layouts");
var design_system_popovers_1 = require("@contrast-security-inc/design-system-popovers");
var DateRangePicker_1 = require("../DateRangePicker");
var design_system_typography_1 = require("@contrast-security-inc/design-system-typography");
var design_system_buttons_1 = require("@contrast-security-inc/design-system-buttons");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var messages = __importStar(require("./translations"));
var SelectModules_1 = require("../SelectModules");
var rangeInputValueCss = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  line-height: 1.2;\n"], ["\n  line-height: 1.2;\n"])));
var DateRangeDropdown = function (_a) {
    var customDateFormat = _a.customDateFormat, customTimeFormat = _a.customTimeFormat, _b = _a.inputHeight, inputHeight = _b === void 0 ? 65 : _b, items = _a.items, label = _a.label, onChangeRange = _a.onChangeRange, selectedRange = _a.selectedRange, _c = _a.monthsToDisplay, monthsToDisplay = _c === void 0 ? 2 : _c, emptyRangePlaceholder = _a.emptyRangePlaceholder, minDate = _a.minDate, maxDate = _a.maxDate, _d = _a.showTime, showTime = _d === void 0 ? true : _d, testId = _a.testId, _e = _a.wrapCustomDateRange, wrapCustomDateRange = _e === void 0 ? true : _e, rest = __rest(_a, ["customDateFormat", "customTimeFormat", "inputHeight", "items", "label", "onChangeRange", "selectedRange", "monthsToDisplay", "emptyRangePlaceholder", "minDate", "maxDate", "showTime", "testId", "wrapCustomDateRange"]);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var _f = (0, design_system_foundations_1.useLocalizationContext)(), formatMessage = _f.formatMessage, formatDate = _f.formatDate, formatTime = _f.formatTime;
    var isCustomRangeOnly = (0, react_1.useMemo)(function () { return items.length === 1 && items[0].type === 'CUSTOM_DATE_RANGE'; }, [items]);
    var _g = (0, react_1.useState)(selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.startDate), startDate = _g[0], setStartDate = _g[1];
    var _h = (0, react_1.useState)(selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.endDate), endDate = _h[0], setEndDate = _h[1];
    var _j = (0, react_1.useState)(false), showDatePicker = _j[0], setShowDatePicker = _j[1];
    var _k = (0, react_1.useState)(undefined), dateRangePickerProps = _k[0], setDateRangePickerProps = _k[1];
    var dropdownRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (selectedRange) {
            setStartDate(selectedRange.startDate);
            setEndDate(selectedRange.endDate);
        }
    }, [selectedRange]);
    var formatDateTime = function (date) {
        if (!date)
            return ''; // Handle empty state
        var formattedDate = customDateFormat ? (0, date_fns_1.format)(date, customDateFormat) : formatDate(date);
        var formattedTime = customTimeFormat ? (0, date_fns_1.format)(date, customTimeFormat) : formatTime(date);
        return "".concat(formattedDate, " ").concat(showTime ? formattedTime : '');
    };
    var renderInputValue = function (selectedRange, isOpen) {
        var formattedStartDate = formatDateTime(startDate);
        var formattedEndDate = formatDateTime(endDate);
        if (!startDate && !endDate) {
            return (react_1.default.createElement(design_system_typography_1.Text, { testId: "".concat(testId, "-input-value"), font: selectedTheme === 'dark' ? 'body' : 'bodyItalic', color: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { dark: 'neutral50', light: 'neutral70' }) }, emptyRangePlaceholder !== null && emptyRangePlaceholder !== void 0 ? emptyRangePlaceholder : formatMessage(messages, 'empty_placeholder')));
        }
        return !isOpen && selectedRange.type !== 'CUSTOM_DATE_RANGE' ? (react_1.default.createElement(design_system_popovers_1.Tooltip, { body: "".concat(formattedStartDate, " - ").concat(formattedEndDate) },
            react_1.default.createElement(design_system_typography_1.Text, { testId: "".concat(testId, "-input-value"), as: "div", font: "bodyStrong" }, getItemLabel(selectedRange)))) : (react_1.default.createElement(design_system_layouts_1.Stack, { flexDirection: wrapCustomDateRange ? 'column' : 'row', spacing: "0px", testId: "".concat(testId, "-selected-item-input-value-stack") },
            react_1.default.createElement(design_system_layouts_1.Stack, { spacing: "0px", flexDirection: "row", alignItems: "center", className: rangeInputValueCss },
                react_1.default.createElement(design_system_typography_1.Text, { testId: "".concat(testId, "-input-value-startDate"), as: "div", font: "bodyStrong", className: rangeInputValueCss }, formattedStartDate),
                "\u00A0\u2013\u00A0"),
            react_1.default.createElement(design_system_typography_1.Text, { testId: "".concat(testId, "-input-value-endDate"), as: "div", font: "bodyStrong", className: rangeInputValueCss }, formattedEndDate)));
    };
    function getItemLabel(item) {
        var _a;
        if (item.type === 'CUSTOM_DATE_RANGE') {
            return (_a = item.label) !== null && _a !== void 0 ? _a : formatMessage(messages, 'title_customDate');
        }
        switch (item.unit) {
            case 'MINUTES':
                return formatMessage(messages, 'detail_nMinutes', { count: item.count });
            case 'HOURS':
                return formatMessage(messages, 'detail_nHours', { count: item.count });
            case 'DAYS':
                return formatMessage(messages, 'detail_nDays', { count: item.count });
            case 'WEEKS':
                return formatMessage(messages, 'detail_nWeeks', { count: item.count });
            case 'MONTHS':
                return formatMessage(messages, 'detail_nMonths', { count: item.count });
            case 'YEARS':
                return formatMessage(messages, 'detail_nYears', { count: item.count });
            default:
                return '';
        }
    }
    function closeDatePicker() {
        setShowDatePicker(false);
    }
    function getItemId(item) {
        var _a;
        if (item.type === 'RELATIVE_TO_NOW') {
            return "".concat(item.type, " ").concat(item.count, " ").concat(item.unit);
        }
        else {
            return (_a = item.label) !== null && _a !== void 0 ? _a : item.type;
        }
    }
    function renderCustomItem(item) {
        var isSelected = false;
        if (selectedRange) {
            if (item.type === 'CUSTOM_DATE_RANGE') {
                var selectedItem = selectedRange;
                isSelected = item.type === selectedItem.type;
            }
            else if (item.type === 'RELATIVE_TO_NOW') {
                var selectedItem = selectedRange;
                isSelected = item.count === selectedItem.count && item.unit === selectedItem.unit;
            }
        }
        return react_1.default.createElement("span", { className: isSelected ? (0, SelectModules_1.highlightedTextStyles)(selectedTheme) : '' }, getItemLabel(item));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Dropdown_1.Dropdown, __assign({}, rest, { testId: testId, ref: dropdownRef, value: { type: 'RELATIVE_TO_NOW', count: -1, unit: 'DAYS' }, itemToID: getItemId, itemToString: getItemLabel, customRender: renderCustomItem, renderInputValue: function (_, isOpen) {
                if (selectedRange) {
                    return renderInputValue(selectedRange, isOpen);
                }
                return (react_1.default.createElement(design_system_typography_1.Text, { testId: "".concat(testId, "-input-value"), font: selectedTheme === 'dark' ? 'body' : 'bodyItalic', color: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { dark: 'neutral50', light: 'neutral70' }) }, emptyRangePlaceholder !== null && emptyRangePlaceholder !== void 0 ? emptyRangePlaceholder : formatMessage(messages, 'empty_placeholder')));
            }, items: items, label: label, onChange: function (_, selectedItem) {
                if (selectedItem) {
                    var isCustom = selectedItem.type === 'CUSTOM_DATE_RANGE';
                    if (isCustom) {
                        setShowDatePicker(true);
                        setDateRangePickerProps(selectedItem.props);
                        setStartDate(selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.startDate);
                        setEndDate(selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange.endDate);
                    }
                    else if (selectedItem.type === 'RELATIVE_TO_NOW') {
                        var dateRange = getRelativeRange(selectedItem);
                        onChangeRange(dateRange);
                    }
                }
            }, inputWrapperSpanClassName: (0, css_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          ", "\n        "], ["\n          ", "\n        "])), wrapCustomDateRange && "height: ".concat(inputHeight, "px;")), enableOpenListboxStyles: !isCustomRangeOnly, onClick: function (event) {
                if (isCustomRangeOnly) {
                    event.preventDefault();
                    setShowDatePicker(true);
                    return;
                }
                closeDatePicker();
            }, isDisabled: showDatePicker, showOverflowTooltip: false })),
        react_1.default.createElement(design_system_popovers_1.Popover, { testId: "".concat(testId, "-custom-popover"), referenceElement: dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current, placement: "bottom-start", isOpen: showDatePicker, onClose: closeDatePicker },
            react_1.default.createElement(DateRangePicker_1.DateRangePicker, __assign({ startDate: startDate, endDate: endDate, minDate: minDate, maxDate: maxDate !== null && maxDate !== void 0 ? maxDate : 'NOW', monthsToDisplay: monthsToDisplay, onStartDateSelected: function (startDate) {
                    setStartDate(startDate);
                }, onEndDateSelected: function (endDate) {
                    setEndDate(endDate);
                } }, dateRangePickerProps)),
            react_1.default.createElement("span", { className: (0, css_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            display: flex;\n            flex-direction: row;\n            justify-content: flex-end;\n            gap: 16px;\n            margin-bottom: 24px;\n            margin-right: 24px;\n          "], ["\n            display: flex;\n            flex-direction: row;\n            justify-content: flex-end;\n            gap: 16px;\n            margin-bottom: 24px;\n            margin-right: 24px;\n          "]))) },
                react_1.default.createElement(design_system_buttons_1.Button, { variant: "secondary", onClick: closeDatePicker }, formatMessage(messages, 'action_cancel')),
                react_1.default.createElement(design_system_buttons_1.Button, { isDisabled: !startDate || !endDate, variant: "primary", onClick: function () {
                        if (startDate && endDate) {
                            onChangeRange({
                                type: 'CUSTOM_DATE_RANGE',
                                startDate: startDate,
                                endDate: endDate,
                            });
                            closeDatePicker();
                        }
                    } }, formatMessage(messages, 'action_apply'))))));
};
exports.DateRangeDropdown = DateRangeDropdown;
function getRelativeRange(item) {
    var endDate = new Date();
    var startDate = new Date(endDate);
    switch (item.unit) {
        case 'MINUTES':
            startDate.setMinutes(endDate.getMinutes() - item.count);
            break;
        case 'HOURS':
            startDate.setHours(endDate.getHours() - item.count);
            break;
        case 'DAYS':
            startDate.setDate(endDate.getDate() - item.count);
            break;
        case 'WEEKS':
            startDate.setDate(endDate.getDate() - item.count * 7);
            break;
        case 'MONTHS':
            startDate.setMonth(endDate.getMonth() - item.count);
            break;
        case 'YEARS':
            startDate.setFullYear(endDate.getFullYear() - item.count);
            break;
    }
    return __assign({ startDate: startDate, endDate: endDate }, item);
}
exports.getRelativeRange = getRelativeRange;
var templateObject_1, templateObject_2, templateObject_3;
